import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { FacebookIcon } from '../../assets/icons'
import { encodeShareURL, openPopup } from '../../helpers/sharing_helper'

export const facebookShareAction = ({ shareUrl, utmParams }: BaseShareActionArgs) =>
  openPopup(`https://www.facebook.com/sharer/sharer.php?u=${encodeShareURL(shareUrl, utmParams)}`)

export const FacebookButton = buildShareButtonComponent({
  action: facebookShareAction,
  ariaLabel: 'Facebook',
  className: 'share-button--facebook',
  icon: FacebookIcon,
})

export type FacebookButtonProps = Parameters<typeof FacebookButton>['0']
